// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__286B_","tooltipText":"styles_tooltipText__e8cPp","info":"styles_info__xDNWL","tooltip":"styles_tooltip__17_Lv"};